<template>
  <div class="page-column">
    <Header></Header>
    <ActivityContent />
    <Footer />
    <BackTop />
  </div>
</template>

<script>
import Header from './Header'
import ActivityContent from './components/ActivityContent'
import Footer from './Footer'
import BackTop from '@comm/components/public/BackTop'
export default {
  components: {
    Header,
    ActivityContent,
    Footer,
    BackTop,
  },
}
</script>

<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/layout/Activity.vue